<template>
  <div class="text-center">
    <v-dialog
      persistent
      v-model="dialog"
      width="500"
    >
      <v-card>
       
          <TabAbonosVue :idabono="idabono" :idcredito="idcredito"/>
       

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="cerrarModal"
          >
            Cerrar ventana
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import TabAbonosVue from './TabAbonos.vue'
  export default {
    components:{
        TabAbonosVue
    },
    props:['dialog','idcredito'],
    data () {
      return {
        idabono: 0,
      }
    },
    methods:{
        async cerrarModal(){
          await  this.$store.dispatch('setAllCreditos')   
            this.$emit('closeModalAbonos')
        }
    }
  }
</script>